<template>
    <div class="selectService">
        <div class="text-xs-center">
            <h1>ระบบประเมินการให้บริการ</h1>
        </div>
        <div class="text-xs-center mt-4 blue--text">
            <h2>
<!--                <span v-if="data_staff.hasOwnProperty('EORG_04')&&data_staff.EORG_04!='Other'||!show_dept_list">-->
<!--                    <v-icon class="blue&#45;&#45;text">mdi-calendar-check</v-icon>-->
<!--                    ฝ่าย {{ data_staff.EORG_04 }}-->
<!--                </span>-->
<!--                <v-layout row wrap v-else>-->
                <v-layout row wrap>

                    <v-flex  xs12 sm6 md6 offset-md3 offset-sm3 class="align-center mt-2">
                        <v-autocomplete
                                v-model="selected_dept"
                                cache-items
                                label="เลือกฝ่ายของผู้ให้บริการ"
                                color="primary"
                                :items="dept_list"
                                item-text="dept_name"
                                item-value="dept_id"
                                persistent-hint
                                :hint="'กรุณาเลือกฝ่ายผู้ให้บริการ หรือ พิมพ์เพื่อค้นหา'"
                                @input="getDeptService('clear')"
                        >
                        </v-autocomplete>

                        <small>
                            <v-btn round  small color="green" class="white--text" @click="getService(true)">
                                <v-icon>cached</v-icon>
                                &nbsp;&nbsp;คืนค่า
                            </v-btn>
                        </small>

                    </v-flex>
                </v-layout>
            </h2>
        </div>
        <v-layout row wrap>
            <v-flex xs12 sm6 md6 offset-md3 offset-sm3 class="align-center mt-2">
                <v-list class="transparent" v-if="found_service">
                    <template v-for="(item, index) in service_list.result">
                        <v-list-tile
                                :key="item.serviceD_id"
                                @click="setSelectedService(item)"
                                class="blue mt-3 v-btn--round white--text"
                        >
                            <v-list-tile-content>
                                <v-list-tile-title v-html="item.serviceD_name"></v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                </v-list>
                <div v-else>
                    <v-alert
                            :value="true"
                            color="warning"
                            icon="priority_high"
                            outline
                    >
                        ไม่พบข้อมูลงานบริการ
                    </v-alert>
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>

    import EventBus from '@/EventBus'
    import axios from '@/axios'

    export default{
        name:"SelectService",
        props:{
            selected_dept_prop:String
        },
        data(){
            return{
                service_list:[],
                dept_list:[],
                localitem:this.getLocalItem(),
                data_staff:{},
                selected_dept: this.selected_dept_prop,
                found_service:true
                //show_dept_list:false
            }
        },
        mounted(){
            window.scrollTo(0,0)
            EventBus.$emit('set_navigation', {title:'เมนู',back_route:'home'})
            this.getDeptService()
        },
        async created() {
            // this.setAuthHeader()
            await this.getDataStaff()
            // if(this.data_staff.hasOwnProperty('EORG_04')&&this.data_staff.EORG_04!='Other'){
            //     await this.getService()
            // }else {
            //     this.show_dept_list = true;
            //     await this.getDeptList()
            // }
            await this.getDeptList()
            if(this.data_staff.hasOwnProperty('EORG_04')&&this.data_staff.EORG_04!='Other') {
                if (!localStorage.getItem('svea_selected_dept')) {
                    await this.getService()
                    if (this.service_list.hasOwnProperty('result')) {
                        this.selected_dept = this.service_list.result.length>0 ? this.service_list.result[0].dept_id:null
                    }
                }

            }
            if (this.selected_dept) {
                await this.getDeptService()
            }
        },
        methods:{
            async getService(origin_reset)
            {
                try{
                    const uri = '/GetService'
                    const localitem = this.getLocalItem()
                    const res = await axios.post(uri, {
                        username:localitem.user_id,
                    })
                    if(origin_reset){
                        this.selected_dept = res.data.result.length>0 ? res.data.result[0].dept_id:null
                        this.getDeptService('clear')
                    }else {
                        this.service_list = res.data
                    }
                }catch(err)
                {
                    if(origin_reset) {
                        this.selected_dept = null
                    }else{
                        this.service_list = []
                    }

                    console.log(err.message)
                }
            },
            setSelectedService(item){
                this.$emit('set_selected_service',item)
                this.$emit('set_selected_dept',item)

            },
            async getDataStaff()
            {
                try{
                    const uri = '/getDataStaff'
                    const res = await axios.post(uri, {
                        query_value:this.localitem.user_id,
                        field_type:'USERNAME'
                    })
                    if(res.data.status=='ok') {
                        this.data_staff = res.data.result
                    }else{
                        this.data_staff = {}
                    }
                }catch(err)
                {
                    this.data_staff = {}
                    console.log(err.message)
                }
            },
            async getDeptList()
            {
                try{
                    const uri = '/getDeptList'
                    const res = await axios.post(uri, {})
                    if(res.data.status=='ok') {
                        this.dept_list = res.data.result
                        if (localStorage.getItem('svea_selected_dept')){
                            this.selected_dept = JSON.parse(localStorage.getItem('svea_selected_dept'))
                        }
                    }
                }catch(err)
                {
                    this.dept_list = []
                    console.log(err.message)
                }
            },
            async getDeptService(clear_list)
            {
                if(clear_list=='clear') {
                    this.service_list = []
                }
                try{
                    const uri = '/getDeptService'
                    const res = await axios.post(uri, {qfield:'dept_id',qval:(this.selected_dept ? this.selected_dept:0)})
                    this.service_list = res.data
                    if(this.service_list.hasOwnProperty('result')&&this.service_list.result.length==0){
                        this.found_service = false
                    }else{
                        this.found_service = true
                    }
                    if(this.selected_dept) {
                        localStorage.setItem('svea_selected_dept', JSON.stringify(this.selected_dept))
                    }
                }catch(err)
                {
                    this.service_list = []
                    console.log(err.message)
                }
            }
        }
    }
</script>

<style>
</style>